import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { useTranslation } from '../i18n/LanguageContext';

const FAQSection = () => {
  const { t } = useTranslation();
  
  const faqs = [
    { id: 1, question: t('faq.questions.q1.question'), answer: t('faq.questions.q1.answer') },
    { id: 2, question: t('faq.questions.q2.question'), answer: t('faq.questions.q2.answer') },
    { id: 3, question: t('faq.questions.q3.question'), answer: t('faq.questions.q3.answer') },
    { id: 4, question: t('faq.questions.q4.question'), answer: t('faq.questions.q4.answer') },
    { id: 5, question: t('faq.questions.q5.question'), answer: t('faq.questions.q5.answer') },
    { id: 6, question: t('faq.questions.q6.question'), answer: t('faq.questions.q6.answer') }
  ];

  return (
    <section id="faq" className="section-spacing-large bg-cream">
      <div className="container-narrow">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="gold-accent mx-auto" />
          <h2 className="section-title mb-6">
            {t('faq.headline')}
          </h2>
          <p className="subtitle">
            {t('faq.body')}
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq) => (
            <AccordionItem 
              key={faq.id} 
              value={`item-${faq.id}`}
              className="bg-white border-none px-6 py-2 rounded-none shadow-sm hover:shadow-md transition-shadow"
            >
              <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-gold transition-colors py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            {t('faq.ctaText')}
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('kontakt');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="btn-secondary"
          >
            {t('faq.ctaButton')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
